import { Loading } from "@/components";

const PendingComponent = () => {
	return (
		<div className="relative wrapper h-full">
			<Loading status />
		</div>
	);
};

export default PendingComponent;
